import { http } from '../utils/http'
import md5 from 'js-md5'
import envUtils from '@/utils/envUtils'

export const UABASE = '/aicc-ua'
export const BPBASE = envUtils('VUE_APP_BP_SERVICE')
export const WBBASE = envUtils('VUE_APP_WB_SERVICE')
export const ORDERBASE = envUtils('VUE_APP_ORDER_SERVICE')

export const login = async ({ tenantId, username, password }) => {
  const md5Password = md5(password)
  const params = {
    username: username,
    password: md5Password,
    tenantId
  }
  return http.get(`${UABASE}/auth/login`, {
    params
  })
}

/**
 * 重置超管密码:获取手机验证码
 */
export const getVerifyCode = async ({ type, telephone }) => {
  return new Promise((resolve, reject) => {
    const params = {
      type,
      telephone
    }
    http.get(`${BPBASE}/data/tenant/requestVerifiCode`, { params }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

/**
 * 重置超管密码:执行重置超管密码
 */
export const resetSuperPassword = async ({ telephone, superPassword }) => {
  return new Promise((resolve, reject) => {
    const data = {
      telephone,
      superPassword: md5(superPassword.toString())
    }
    http.put(`${BPBASE}/data/tenant/resetSuperPassword`, { data }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

export const getUserApi = async () => {
  return http.get(`${UABASE}/auth/getUser`)
}

// export const logout = async (token) => {
//   return http.post(`${UABASE}/auth/logout`, { token })
// }

/**
 * 获取角色列表
 */
export const listRoles = async () => {
  return new Promise((resolve, reject) => {
    http.get(`${UABASE}/role/listRoles`).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}
/**
 * 获取角色分页列表
 */
export const listRolesPage = async ({ pageNum, pageSize }) => {
  const params = {
    pageNum,
    pageSize
  }
  return new Promise((resolve, reject) => {
    http.get(`${UABASE}/role/listRolesPage`, { params }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

/**
 * 获取角色类型列表
 */
export const listRoleType = async () => {
  return new Promise((resolve, reject) => {
    http.get(`${UABASE}/role/listRoleType`).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

export const getRolePermission = async ({ queryType, roleId, app, containApp }) => {
  containApp = typeof (containApp) === 'undefined'
  const params = {
    queryType,
    roleId,
    app,
    containApp
  }
  return new Promise((resolve, reject) => {
    http.get(`${UABASE}/auth/getPermission`, { params }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

export const getAppAllPermission = async ({ app, queryType, roleId }) => {
  const params = {
    queryType,
    roleId
  }
  return new Promise((resolve, reject) => {
    http.get(`/${app}/auth/getPermission`, { params }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

/**
 * 新增userGroup
 * @param {*} param
 */
export const addUserGroup = async ({ name, parentId }) => {
  const data = {
    name,
    parentId
  }
  return new Promise((resolve, reject) => {
    http.post(`${UABASE}/ug/addUserGroup`, { data }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

/**
 * 编辑userGroup
 * @param {*}
 */
export const editUserGroup = ({ id, name, parentId }) => {
  const data = {
    id,
    name,
    parentId
  }
  return new Promise((resolve, reject) => {
    http.put(`${UABASE}/ug/editUserGroup`, { data }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

/**
 * 删除userGroup
 * @param {*}
 */
export const deleteUserGroup = async ({ id }) => {
  const params = {
    id
  }
  return new Promise((resolve, reject) => {
    http.delete(`${UABASE}/ug/deleteUserGroup`, { params }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

/**
 * 获取userGroup树
 * type = 0  只获取组织树，不带坐席人员
 * type = 1  获取组织树+坐席人员
 */
export const getUserGroupTree = async (type) => {
  type = type || ''
  return new Promise((resolve, reject) => {
    http.get(`${UABASE}/ug/getUserGroupTree`, { params: { type: type } }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

/**
 * 获取当前坐席组还有几层子节点,包含自身
 */
export const getUserGroupChildLevel = async ({ userGroupBH }) => {
  return new Promise((resolve, reject) => {
    http.get(`${UABASE}/ug/getUserGroupChildLevel`, { params: { userGroupBH: userGroupBH } }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

/**
 * 批量修改分组
 */
export const batchUpdateUserGroup = async ({ targetId, list }) => {
  const data = {
    targetId,
    list
  }
  return new Promise((resolve, reject) => {
    http.put(`${UABASE}/ug/batchUpdateUserGroup`, { data }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

/**
 * 获取用户列表
 */
export const listUser = async ({ groupId, roleId, searchText, pageNum, pageSize }) => {
  groupId = groupId || ''
  const params = {
    groupId,
    roleId,
    searchText,
    pageNum,
    pageSize
  }
  return new Promise((resolve, reject) => {
    http.get(`${UABASE}/user/listUser`, { params }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

/**
 * 获取用户
 */
export const getUser = async (id) => {
  return new Promise((resolve, reject) => {
    http.get(`${UABASE}/user/getUser/${id}`).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

/**
 * 新增用户
 */
export const addUser = async (formData) => {
  let md5Pass = ''
  if (!(formData.password === '' || formData.password === '••••••')) {
    md5Pass = md5(formData.password)
  } else {
    md5Pass = formData.password
  }
  const data = {
    id: formData.id,
    userName: formData.userName,
    idNum: formData.idNum,
    password: md5Pass,
    nickname: formData.nickname,
    realName: formData.realName,
    email: formData.email,
    mobile: formData.mobile,
    roleId: formData.roleId,
    maxReception: formData.maxReception,
    userGroupId: formData.groupId,
    isCharge: formData.chargeGroup,
    welcome: formData.welcome,
    avatar: formData.avatar,
    shortcutKeys: formData.shortcutKeys
  }
  return new Promise((resolve, reject) => {
    http.post(`${UABASE}/user/addUser`, { data }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

/**
 * 编辑用户
 */
/* export const editUser = (formData) => {
  const data = {
    userName: formData.userName,
    idNum: formData.idNum,
    password: formData.password,
    nickname: formData.nickname,
    realName: formData.realName,
    email: formData.email,
    mobile: formData.mobile,
    roleId: formData.roleId,
    maxReception: formData.maxReception,
    userGroupId: formData.groupId,
    isCharge: formData.isCharge
  }
  return new Promise((resolve, reject) => {
    http.put(`${UABASE}/user/editUser`, { data }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
} */

/**
 * 删除用户
 */
export const deleteUser = async (id) => {
  return new Promise((resolve, reject) => {
    http.delete(`${UABASE}/user/deleteUser/${id}`).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}
/**
 * 批量删除用户
 */
export const batchDeleteUser = async ({ rows }) => {
  const data = {
    rows
  }
  return new Promise((resolve, reject) => {
    http.delete(`${UABASE}/user/batchDeleteUser`, { data }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

/**
 * 添加角色
 */
export const addRole = async (formData) => {
  const data = {
    id: formData.id,
    roleName: formData.name,
    description: formData.description,
    roleType: formData.roleType,
    sysAuth: formData.sysAuth,
    wbAuth: formData.wbAuth
  }
  return new Promise((resolve, reject) => {
    http.post(`${UABASE}/role/editRole`, { data }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

/**
 * 添加APP角色权限
 */
export const addAppRole = async (obj) => {
  const app = obj.app
  const data = {
    roleId: obj.roleId,
    data: JSON.stringify(obj.data)
  }
  return new Promise((resolve, reject) => {
    http.post(`/${app}/auth/postPermission`, { data }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

/**
 * 添加APP角色权限
 */
export const deleteAppRole = async (app, id) => {
  const params = {
    roleId: id
  }
  return new Promise((resolve, reject) => {
    http.delete(`/${app}/auth/deletePermission`, { params }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

/**
 * 获取SkillGroup列表
 */
export const listSkillGroup = async () => {
  return new Promise((resolve, reject) => {
    http.get(`${UABASE}/skill/listSkillGroup`).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

/**
 * 获取角色
 */
export const getRoleById = async (id) => {
  return new Promise((resolve, reject) => {
    http.get(`${UABASE}/role/getRole/${id}`).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

/**
 * 删除角色
 */
export const deleteRoleById = async (id) => {
  return new Promise((resolve, reject) => {
    http.delete(`${UABASE}/role/deleteRole/${id}`).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

/**
 * 添加技能组
 */
export const addSkillGroup = async (name) => {
  const data = {
    name
  }
  return new Promise((resolve, reject) => {
    http.post(`${UABASE}/skill/addSkillGroup`, { data }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

/**
 * 删除技能组
 */
export const deleteSkillGroup = async (id) => {
  return new Promise((resolve, reject) => {
    http.delete(`${UABASE}/skill/deleteSkillGroup/${id}`).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

/**
 * 添加技能组用户
 */
export const addSkillGroupMem = async ({ skillId, memberIds }) => {
  const data = {
    skillId, memberIds
  }
  return new Promise((resolve, reject) => {
    http.post(`${UABASE}/skill/addSkillGroupMem`, { data }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

/**
 * 获取SkillGroup列表
 */
export const listSkillGroupUser = async ({ skillId, searchText, pageNum, pageSize }) => {
  const params = {
    skillId, searchText, pageNum, pageSize
  }
  return new Promise((resolve, reject) => {
    http.get(`${UABASE}/skill/listSkillGroupUser`, { params }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

/**
 * 删除技能组成员
 */
export const deleteSkillGroupMember = async ({ rows, skillId }) => {
  const data = {
    rows
  }
  return new Promise((resolve, reject) => {
    http.delete(`${UABASE}/skill/deleteSkillGroupMember?skillId=${skillId}`, { data }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

/**
 * 批量修改用户角色
 */
export const batchUpdateUserRole = async ({ targetId, list }) => {
  const data = {
    targetId,
    list
  }
  return new Promise((resolve, reject) => {
    http.put(`${UABASE}/user/batchUpdateUserRole`, { data }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

/**
 * 添加技能组
 */
export const lockUser = async ({ userId, status }) => {
  const params = {
    userId, status
  }
  return new Promise((resolve, reject) => {
    http.put(`${UABASE}/user/lockUser`, { params }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

/**
 * 根据工号查找用户
 */
export const getUserByProp = async ({ id, idNum, userName }) => {
  const data = {
    id, idNum, userName
  }
  return new Promise((resolve, reject) => {
    http.post(`${UABASE}/user/getUserByProp`, { data }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

/**
 * 踢出当前角色下的登陆用户
 */
export const kickUser = async ({ roleId }) => {
  const params = {
    roleId
  }
  return new Promise((resolve, reject) => {
    http.get(`${UABASE}/role/kickUser`, { params }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

/**
 * 获取渠道信息
 */
export const getPlatforms = async () => {
  const params = {
  }
  return new Promise((resolve, reject) => {
    http.get(`${BPBASE}/acd/getPlatforms`, { params }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

/**
 * 获取一个随机Id
 */
export const getRandomUUID = async ({ random }) => {
  const params = {
  }
  return new Promise((resolve, reject) => {
    http.get(`${UABASE}/auth/getRandomUUID?random=${random}`, { params }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

/**
 * 根据ID获取策略
 */
export const getAcdById = async ({ acdId }) => {
  const params = {
    acdId
  }
  return new Promise((resolve, reject) => {
    http.get(`${BPBASE}/acd/getAcdById`, { params }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

/**
 * 保存策略
 */
export const saveAcd = async ({ acd }) => {
  const data = acd
  return new Promise((resolve, reject) => {
    http.post(`${BPBASE}/acd/editAcd`, { data }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

/**
 * 获取acd列表
 */
export const listAcds = async ({
  startTime,
  endTime,
  channelIds,
  kwyWord,
  pageNum,
  pageSize
}) => {
  const params = {
    startTime,
    endTime,
    channelIds,
    kwyWord,
    pageNum,
    pageSize
  }
  return new Promise((resolve, reject) => {
    http.get(`${BPBASE}/acd/listAcds`, { params }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

/**
 * 删除策略
 */
export const deleteAcd = async ({ acdId }) => {
  const params = { acdId }
  return new Promise((resolve, reject) => {
    http.delete(`${BPBASE}/acd/deleteAcd`, { params }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

/**
 * 根据名称获取策略
 */
export const getAcdByNameAndId = async ({ acdName, acdId }) => {
  const params = { acdName, acdId }
  return new Promise((resolve, reject) => {
    http.get(`${BPBASE}/acd/getAcdByNameAndId`, { params }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

/**
 * 获取平台策略列表
 */
export const listPlatformAcds = async ({
  pageNum,
  pageSize
}) => {
  const params = {
    pageNum,
    pageSize
  }
  return new Promise((resolve, reject) => {
    http.get(`${BPBASE}/acd/platform/listPlatformAcds`, { params }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

/**
 * 根据id获取平台策略信息
 */
export const getPlatformAcdById = async ({
  id
}) => {
  const params = {
    id
  }
  return new Promise((resolve, reject) => {
    http.get(`${BPBASE}/acd/platform/getPlatformAcdById`, { params }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

/**
 * 保存平台策略
 */
export const savePlatformAcd = async (configs) => {
  return new Promise((resolve, reject) => {
    http.post(`${BPBASE}/acd/platform/savePlatformAcd`, { data: configs }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

/**
 * 根据id获取平台策略信息
 */
export const deletePlatformAcdById = async ({
  id
}) => {
  const params = {
    id
  }
  return new Promise((resolve, reject) => {
    http.delete(`${BPBASE}/acd/platform/deletePlatformAcdById`, { params }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

/**
 * 获取平台信息
 */
export const getDimensions = async ({ detail }) => {
  const params = {
    detail
  }
  return new Promise((resolve, reject) => {
    http.get(`${BPBASE}/acd/platform/getDimensions`, { params }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

/**
 * 根据channelids获取策略
 */
export const getAcdByChannelIds = async ({ channelIds }) => {
  const data = channelIds

  return new Promise((resolve, reject) => {
    http.post(`${BPBASE}/acd/platform/getAcdByChannelIds`, { data }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

/**
 * 保存黑名单
 */
export const addBlacklistItem = async ({ visitorId, platformIds, unbanTime, banMessage }) => {
  const data = { visitorId, platformIds, unbanTime, banMessage }
  return new Promise((resolve, reject) => {
    http.post(`${BPBASE}/customBlacklist/infinite/addItem`, { data }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

/**
 * 查询
 */
export const listBlacklistItem = async ({ startTime, endTime, searchText, creator, platformIds, pageNum, pageSize }) => {
  const params = { startTime, endTime, searchText, creator, platformIds, pageNum, pageSize }
  return new Promise((resolve, reject) => {
    http.get(`${BPBASE}/customBlacklist/listItem`, { params }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

/**
 * 导出
 */
export const exportBlacklistItem = async ({ startTime, endTime, searchText, creator, platformIds, progressId }) => {
  const params = { startTime, endTime, searchText, creator, platformIds, progressId }
  return new Promise((resolve, reject) => {
    http.get(`${BPBASE}/customBlacklist/exportItems`, { params }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

/**
 * 查询所有操作人
 */
export const listCreator = async () => {
  const params = {}
  return new Promise((resolve, reject) => {
    http.get(`${BPBASE}/customBlacklist/listCreator`, { params }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

/**
 * 删除黑名单
 */
export const deleteItem = async ({ id }) => {
  const params = { id }
  return new Promise((resolve, reject) => {
    http.delete(`${BPBASE}/customBlacklist/deleteItem`, { params }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}
/**
 * 批量删除黑名单
 */
export const batchDeleteItems = async ({ items }) => {
  const data = { items }
  return new Promise((resolve, reject) => {
    http.delete(`${BPBASE}/customBlacklist/batchDeleteItems`, { data }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

/**
* 下载文件
*/
export const downExcelFile = async ({ excelName }) => {
  const params = {
    excelName
  }
  return new Promise((resolve, reject) => {
    http.post(`${BPBASE}/infinite/downExcelFile`, { responseType: 'blob', params: params }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

// export const login = async ({ username, password }) => {
//   const params = {
//     username,
//     password
//   }
//   return http.get(`${UABASE}/auth/login`, {
//     params
//   })
// }

export const getUserId = (token) => {
  return http.get(`${UABASE}/auth/getUserInfo`, {
    params: {
    },
    headers: {
      Authorization: token
    },
    method: 'get'
  })
}

export const getAgentInfo = (userId) => {
  const params = {
    isBpLogin: true
  }
  return http.get(`${WBBASE}/infinite/auth/user/` + userId, { params }, {
    method: 'get'
  })
}

export const logout = (token) => {
  return http.post(`${WBBASE}/infinite/auth/logout`, { token })
}

export const bplogout = (token) => {
  return http.post(`${UABASE}/auth/logout`, { token })
}

// export const getRolePermission = (token) => {
//   return http.get(`${UABASE}/auth/getPermission`, {
//     params: {
//       containsBtn: true,
//       queryType: 1,
//       app: 'aicc_wb'
//     }
//   })
// }

export const getOrderPermission = (roleId) => {
  return http.get(`${ORDERBASE}/auth/getPermission`, {
    params: {
      roleId: roleId,
      platform: 'aicc_wb'
    }
  })
}

/**
 * 坐席获取所有可查看排队队列信息
 */
export const getAllQueueInfo = async ({ agentId }) => {
  const params = {
    agentId
  }
  return new Promise((resolve, reject) => {
    http.get(`${WBBASE}/infinite/queue/getAllQueue`, { params }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

/**
 * 坐席根据队列key获取排队队列信息
 */
export const getQueueInfoByKey = async ({ agentId, queueKey }) => {
  const params = {
    agentId, queueKey
  }
  return new Promise((resolve, reject) => {
    http.get(`${WBBASE}/infinite/queue/getQueueByQueueKey`, { params }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

/**
 * 坐席主动创建会话
 */
export const createInitiativeSession = async ({ agentId, queueKey, visitorId, skillGroupId }) => {
  const params = {
    agentId, queueKey, visitorId, skillGroupId
  }
  return new Promise((resolve, reject) => {
    http.get(`${WBBASE}/infinite/queue/createInitiativeSession`, { params }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

export const getShortcutKeyById = async (id) => {
  return new Promise((resolve, reject) => {
    http.get(`${BPBASE}/user/getShortcutKeyById/` + id).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

export const updateShortcutKeyById = async (id, shortcutKey) => {
  const params = {
    shortcutKey: shortcutKey
  }
  return new Promise((resolve, reject) => {
    http.get(`${BPBASE}/user/updateShortcutKeyById/` + id, { params }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

/**
 * 获取技能组快捷回复信息
 */
export const getQuickReplys = ({ userId, pageNum, pageSize, searchText, searchCategory, searchTitle }) => {
  const params = {
    userId,
    pageNum,
    pageSize,
    searchText,
    searchCategory,
    searchTitle
  }
  return new Promise((resolve, reject) => {
    http.get(`${BPBASE}/quickReply/getAllQRs`, { params }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

export const updateQuickReplys = async ({ quickReplys, userId }) => {
  const params = {
    userId: userId
  }
  return new Promise((resolve, reject) => {
    http.post(`${BPBASE}/quickReply/updateQRs`, { data: quickReplys, params }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

export const addQuickReply = async ({ quickReplys, userId }) => {
  const params = {
    userId: userId
  }
  return new Promise((resolve, reject) => {
    http.post(`${BPBASE}/quickReply/insertQR`, { data: quickReplys, params }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

export const exportQuickReply = async ({ userId }) => {
  const params = {
    userId
  }
  return new Promise((resolve, reject) => {
    http.get(`${BPBASE}/quickReply/export`, { responseType: 'blob', params }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

export const deleteQRByIds = async (ids) => {
  return new Promise((resolve, reject) => {
    http.delete(`${BPBASE}/quickReply/deleteQRByIds`, { data: ids }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

export const getAllQuickReplys = async (userId, skillGroupId) => {
  const params = {
    userId: userId,
    skillGroupId: skillGroupId
  }
  return new Promise((resolve, reject) => {
    http.get(`${BPBASE}/quickReply/getAllQuickReplys`, { params }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

/**
 * 获取userGroup树
 * type = 0  只获取组织树，不带坐席人员
 * type = 1  获取组织树+坐席人员
 */
// export const getUserGroupTree = async (type, needAuth) => {
//   type = type || ''
//   return new Promise((resolve, reject) => {
//     http.get(`${UABASE}/ug/getUserGroupTree`, { params: { type: type, needAuth: needAuth } }).then(res => {
//       resolve(res.data)
//     }).catch(err => {
//       reject(err)
//     })
//   })
// }

/**
 * 获取技能组列表
 */
export const getSkillGroupData = async ({ userGroupIds }) => {
  const params = {
    userGroupIds
  }
  return new Promise((resolve, reject) => {
    http.get(`${BPBASE}/skillgroup/getSkillGroup`, params).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

/**
 * 获取坐席列表
 */
export const getAgentsByCondition = async ({ sgIds, xzIds }) => {
  const data = {
    sgIds, xzIds
  }
  return new Promise((resolve, reject) => {
    http.post(`${BPBASE}/user/getAgents`, { data }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

/**
 * 获取平台信息
 */
// export const getDimensions = async () => {
//   const params = {
//   }
//   return new Promise((resolve, reject) => {
//     http.get(`${BPBASE}/acd/platform/getDimensions`, { params }).then(res => {
//       resolve(res.data)
//     }).catch(err => {
//       reject(err)
//     })
//   })
// }

/*
* 获取所有的平台信息
*/
export const getChannelPlatforms = async () => {
  return new Promise((resolve, reject) => {
    http.get(`${BPBASE}/acd/getPlatforms`).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

export const exportChatLog = async (formData) => {
  const data = { ...formData }
  const params = {
    progressTaskId: formData.progressTaskId
  }
  return http.post(`${WBBASE}/slog/export`, { data: data, params })
}

export const getCustomTags = async () => {
  return http.post(`${WBBASE}/customTag/list`)
}
